import { render, staticRenderFns } from "./MovePosition.vue?vue&type=template&id=a70ff372&lang=pug"
import script from "./MovePosition.vue?vue&type=script&lang=js"
export * from "./MovePosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports